import { APP_INITIALIZER, Provider, inject } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { TokenRefreshCoordinator } from './services/token-refresh.coordinator';

/**
 * Factory para inicializar autenticação no bootstrap da aplicação
 * Garante que checkAuth seja executado antes da aplicação renderizar.
 * Em falha (storage corrompido / tokens inválidos), limpa sessão local
 * para evitar loop de refresh 400 na sessão do browser.
 */
export function authInitializerFactory() {
  const oidcSecurityService = inject(OidcSecurityService);
  const tokenRefresh = inject(TokenRefreshCoordinator);

  return () => {
    return new Promise<void>((resolve) => {
      oidcSecurityService.checkAuth().subscribe({
        next: () => {
          resolve();
        },
        error: (err) => {
          console.warn('[AUTH] checkAuth falhou — limpando sessão local', err);
          tokenRefresh.clearLocalSession('checkAuth falhou no bootstrap');
          resolve(); // Resolve mesmo com erro para não bloquear app
        }
      });
    });
  };
}

/**
 * Provider para APP_INITIALIZER de autenticação
 */
export const authInitializerProvider: Provider = {
  provide: APP_INITIALIZER,
  useFactory: authInitializerFactory,
  multi: true
};
